export default "/static/media/default.dc2b40a2.css";